var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4C10.4477 4 10 4.44772 10 5V5.2H8C6.89543 5.2 6 6.09543 6 7.2V26C6 27.1046 6.89543 28 8 28H24C25.1046 28 26 27.1046 26 26V7.2C26 6.09543 25.1046 5.2 24 5.2H22V5C22 4.44772 21.5523 4 21 4H11ZM10 7V6.7H8C7.72386 6.7 7.5 6.92386 7.5 7.2V26C7.5 26.2761 7.72386 26.5 8 26.5H24C24.2761 26.5 24.5 26.2761 24.5 26V7.2C24.5 6.92386 24.2761 6.7 24 6.7H22V7C22 7.55228 21.5523 8 21 8H11C10.4477 8 10 7.55228 10 7ZM12.8 11H10.8V13H12.8V11ZM10.8 16H12.8V18H10.8V16ZM12.8 21H10.8V23H12.8V21Z",
    fill: "#8A8A8A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIcon2);
export default __webpack_public_path__ + "static/media/m-icon-2.5b3b738d3ae9a1c95127cbb02be1697b.svg";
export { ForwardRef as ReactComponent };